export default __webpack_public_path__ + "static/media/CUB26-3123.24126959.pdf";